import _get from 'lodash/get';
import * as Types from 'pages/Features/tabs/Profile/TimezoneAndWorkHours/typings';
import getWorkHoursByDayArray from 'pages/Features/tabs/Profile/TimezoneAndWorkHours/helpers/getWorkHoursByDayArray';

function convertTimeoneAndWorkHoursValueForRequest(
  timezoneAndWorkHoursFormValue: Types.TimezoneAndWorkHoursFormState,
): Types.TimezoneAndWorkHoursRequest {
  const hoursEnabled = timezoneAndWorkHoursFormValue.hoursEnabled;
  const locationEnabled = timezoneAndWorkHoursFormValue.locationEnabled;
  const defaultWorkHoursArray = getWorkHoursByDayArray({
    workHoursByDay: timezoneAndWorkHoursFormValue.workHoursByDay,
    hoursEnabled,
    locationEnabled,
  });
  const timezoneEnabled = timezoneAndWorkHoursFormValue.timezoneEnabled;
  const workScheduleEnabled = timezoneAndWorkHoursFormValue.workScheduleEnabled;
  const defaultWorkHoursEnabled = timezoneAndWorkHoursFormValue.defaultWorkHoursEnabled;

  const setDefaultWorkHoursToNull =
    !timezoneEnabled ||
    !workScheduleEnabled ||
    !defaultWorkHoursEnabled ||
    !defaultWorkHoursArray.length;
  const timezoneAndWorkHoursSettingsToSave = {
    timezone: {
      enabled: timezoneAndWorkHoursFormValue.timezoneEnabled,
    },
    workHours: {
      hoursEnabled: timezoneAndWorkHoursFormValue.hoursEnabled,
      locationEnabled: timezoneAndWorkHoursFormValue.locationEnabled,
      defaultWorkHours: setDefaultWorkHoursToNull ? null : defaultWorkHoursArray,
    },
  };

  return timezoneAndWorkHoursSettingsToSave;
}

export default convertTimeoneAndWorkHoursValueForRequest;
